import React, { FC, useContext, useEffect, useMemo, useState } from 'react'
import { getErrorAsLoadable, getValueAsLoadable, LoadableValue, LOADING, mapLoadable } from '../../../../../utils/loadingValue'
import { getTaskDetail } from '../../services/task.api'
import { Grid, useMediaQuery, withStyles } from '@material-ui/core'
import { colors, DEFAULT_LABEL, STATUTS_TACHE, TACHE_TYPE_ENTITE, TYPE_DIALOG } from '../../../../../utils/constants'
import Loader from '../../../../../components/layout/Loader'
import { getStyles } from 'isotope-client'
import { compose } from 'redux'
import IconButton from '@material-ui/core/IconButton'
import { injectTypeTacheValueList } from '../../../../common/valueLists/valueListInjectors'
import { FormattedMessage, useIntl } from 'react-intl'
import Detail from '../../../planning/component/detail/Detail'
import { getDetailSections } from '../../../gestionTache/utils/tacheUtils'
import { detailTaskStyles } from '../../services/task.styles'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import CreateIcon from '@material-ui/icons/Create'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import { TaskWithDetailsApi } from '../../services/task.types'
import { mapTaskDetailFromApiToApp } from '../../services/task.utils'
import Typography from '@material-ui/core/Typography'
import Button from '../../../../../components/Button'
import ContenuPopinSuppressionErrorTache from '../../../gestionTache/component/planification/ContenuPopinSuppressionErrorTache'
import ContenuPopinSuppressionTache, { formName } from '../../../gestionTache/component/planification/ContenuPopinSuppressionTache'
import FormButton from '../../../../../components/form/FormButton'
import { deleteTasks as deleteTasksApi } from '../../../gestionTache/gestionTachesApi'
import { DialogContext } from '../../../../../components/layout/dialog'
import { useSnackbar } from '../../../../../components/layout/snackbar/SnackbarContext'
import UpdateTaskForm from '../../../tourPlaine/component/panel/UpdateTaskForm'
import { updateTache } from '../../../gestionTache/services/api'
import { PANEL_FORM } from '../../../tourPlaine/tool/tourPlaine.constants'
import { LocalDateTime } from '../../../../../utils/date/local-date-time'
import { useScheduler } from '../../context/SchedulerContext'
import { ValueListEntry } from '../../../../../utils/types/global.types'
import { TaskPanelRedirectionParameters } from '../../services/schedule.types'
import { SubmissionError } from 'redux-form'
import { parseHTMLWithBold } from '../../../../../utils/boldUtils'

const styles = () => getStyles({
	// Container
	container: {
		position: 'relative' as 'relative',
		width: 460,
		height: '100%',
		borderRadius: '0px 0px 12px 0px'
	},
	titleContainer: {
		height: 65
	},
	title: {
		width: 350,
		height: 50,
		borderBottom: '2px solid #55555a',
		textAlign: 'center' as 'center'
	},
	closeIcon: {
		position: 'absolute' as 'absolute',
		top: 6,
		right: 6
	},
	content: {
		overflowY: 'auto' as 'auto'
	},

	// Details
	...detailTaskStyles,

	// Update
	updateContainer: {
		height: 'calc(100vh - 220px)',
		marginBottom: 100
	},
	updateContainerTablette: {
		height: 'calc(100vh - 300px)'
	},
	actions: {
		height: 100,
		position: 'absolute' as 'absolute',
		bottom: 0,
		width: '100%',
		boxSizing: 'border-box' as 'border-box'
	},
	actionsTablette: {
		position: 'absolute' as 'absolute',
		bottom: -50,
		width: '100%',
		boxSizing: 'border-box' as 'border-box'
	},
	submitButton: {
		margin: '0 9px 0 9px',
		padding: '0 10px 0 10px'
	}
})

const popinStyles = {
	titleIcon: {
		color: colors.error,
		marginRight: 8
	},
	container: {
		margin: '12px 24px',
		maxWidth: 600,
		lineHeight: '20px'
	},
	warnings: {
		display: 'block' as 'block',
		whiteSpace: 'pre-line' as 'pre-line',
		textAlign: 'justify' as 'justify',
		margin: '0px 12px 12px 12px'
	}
}

type TaskDetailProps = {
	taskPanelRedirection: TaskPanelRedirectionParameters
	isResultat: boolean
	closeDetail: () => void,
	typeTacheList: ValueListEntry[]
	classes: ClassNameMap
}

type DeleteFormValues = {
	typeSuppression: string
}

type UpdateFormValues = {
	date: string
	duree: number
	ressources: { code: string }[]
	priorite: number
	instructions?: string
	lockDate: boolean
	lockRessources: boolean
}

const TaskDetail: React.FC<TaskDetailProps> = ({taskPanelRedirection, isResultat, closeDetail, typeTacheList, classes}) => {
	const isTablette = useMediaQuery('(min-width: 768px) and (max-width: 1400px)')
	const intl = useIntl()
	const {openDialog, closeDialog} = useContext(DialogContext)
	const {snackError, snackSuccess} = useSnackbar()
	const {refreshScheduler} = useScheduler()
	const [taskDetail, setTaskDetail] = useState<LoadableValue<TaskWithDetailsApi>>(LOADING)
	const [showEditionTask, setShowEditionTask] = useState<boolean>(false)

	useEffect(() => {
		getTaskDetail(taskPanelRedirection.id)
			.then((detail) => {
				setTaskDetail(getValueAsLoadable(mapTaskDetailFromApiToApp(detail)))
				setShowEditionTask(taskPanelRedirection.forEdition ?? false)
			})
			.catch(() => setTaskDetail(getErrorAsLoadable('')))
	}, [taskPanelRedirection, setTaskDetail])

	/**
	 * Permet de renvoyer le lieu formatté correctement
	 * @param task
	 */
	const taskLocationWithDetails = useMemo(() => {
		return mapLoadable(taskDetail, task => {
			let taskLocation = ''
			if (task.assolement == null && task.bloc != null) {
				taskLocation = intl.formatMessage({id: 'enums.typeEntityAndValue.BLOC'}, {bloc: task.bloc.nom})
			} else if (task.typeEntity === TACHE_TYPE_ENTITE.SURFACE || task.typeEntity === TACHE_TYPE_ENTITE.ETAPE) {
				taskLocation = intl.formatMessage({id: 'enums.typeEntityAndValue.SURFACE'}, {planche: task.planche?.nom})
			} else if (task.assolement == null) { // pas d'assolement
				taskLocation = intl.formatMessage({id: 'enums.typeEntityAndValue.FERME'})
			}
			return {
				task: task,
				updateFormDetails: {
					...task,
					materiels: task.materiels.map(m => m.nom),
					lieu: taskLocation,
					plannedDate: taskPanelRedirection?.taskParameters?.start || task.dateDebutPlanification,
					plannedRessources: taskPanelRedirection?.taskParameters?.resources
				}
			} as const
		})
	}, [taskDetail, taskPanelRedirection, intl])

	if (taskLocationWithDetails.loading) {
		return (
			<Grid container item direction="column" className={classes.container} style={{background: isResultat ? 'linear-gradient(#ffffff, #c1d7e5)' : 'linear-gradient(#f7f5f8, #e0d6e6)'}}>
				<Loader fromBo={false} minHeight={false} />
			</Grid>
		)
	}
	if (taskLocationWithDetails.error) {
		return <></>
	}

	const {task, updateFormDetails} = taskLocationWithDetails.value

	const taskName = (typeTacheList.find(type => type.code === task.type) || {}).label || DEFAULT_LABEL

	const openDeletionPopin = () => {
		if (task.etat === STATUTS_TACHE.TERMINEE) {
			openDialog(
				<Grid container spacing={1}>
					<WarningRoundedIcon className={classes.popinTitleIcon} />
					<FormattedMessage id="gestionTaches.toolbar.actions.delete.popin.error.title" />
				</Grid>,
				<ContenuPopinSuppressionErrorTache tachesEnErreur={task} />,
				[], TYPE_DIALOG.ACTION,
				'actions.close'
			)
		} else {
			openDialog(
				{id: 'gestionTaches.toolbar.actions.delete.popin.validation.title'},
				<ContenuPopinSuppressionTache tachesRecurrentes={[]} onSubmit={submitDeletion} />,
				[
					<FormButton
						type="primary"
						formName={formName}
						disabled={false}
						getDisabledFromState={undefined}
					>
						<FormattedMessage id="actions.delete" />
					</FormButton>
				], TYPE_DIALOG.ACTION
			)
		}
	}

	const submitDeletion = (values: DeleteFormValues) => {
		deleteTasksApi([task.id], values.typeSuppression)
			.then(() => {
				refreshScheduler()
				snackSuccess({id: 'gestionTaches.toolbar.actions.delete.success'})
			})
			.catch(() => snackError({id: 'gestionTaches.toolbar.actions.delete.error'}))
			.finally(() => {
				closeDialog()
				closeDetail()
			})
	}

	const updateSuccess = () => {
		refreshScheduler()
		closeDetail()
		closeDialog()
		snackSuccess({id: 'snackbar.update.tourPlaine.generic'})
	}

	const submitUpdate = (values: UpdateFormValues, forceUpdate?: boolean) => {
		return updateTache(task.id, {
			...values,
			date: LocalDateTime.toApiDateTime(new Date(values.date)),
			ressources: values.ressources.map(r => r.code),
			forceUpdate
		})
			.then((result) => {
				if (result.hasWarnings) {
					openDialog(
						<Grid container spacing={1}>
							<WarningRoundedIcon style={popinStyles.titleIcon} />
							<FormattedMessage id="tourPlaine.form.updateTask.warnings.title" />
						</Grid>,
						<Grid container style={popinStyles.container}>
							<FormattedMessage id="tourPlaine.form.updateTask.warnings.description" />
							<br />
							<Grid item xs={12} style={popinStyles.warnings}>
								{result.warnings.map((warning: string) => <>
									{parseHTMLWithBold(`${intl.formatMessage({id: 'tourPlaine.form.updateTask.warnings.item'}, {warning})}`)}
									<br />
								</>)}
							</Grid>

						</Grid>,
						[
							<Button
								type="primary"
								onClick={() => submitUpdate(values, true)}
							>
								<FormattedMessage id="actions.confirm" />
							</Button>
						],
						TYPE_DIALOG.ACTION,
						'actions.cancel',
						undefined,
						true
					)
				} else {
					updateSuccess()
					setShowEditionTask(false)
				}
			})
			.catch((e) => {
				snackError({id: 'snackbar.error.tourPlaine.generic'})
				throw new SubmissionError(e)
			})
	}

	const sections = getDetailSections(task, isResultat && {...(taskPanelRedirection.taskParameters || {}), unplanned: taskPanelRedirection.unplanned}, !isResultat, classes, intl)

	return <Grid container item direction="column" className={classes.container} style={{background: isResultat ? 'linear-gradient(#ffffff, #c1d7e5)' : 'linear-gradient(#f7f5f8, #e0d6e6)'}}>
		<Grid item container>
			<Grid item container direction="row" justify="center" alignContent="flex-end" className={classes.titleContainer}>
				<Grid item container justify="center" alignContent="center" className={classes.title}>
					<Typography component="h3" variant="h3">
						<FormattedMessage
							id="schedule.solution.detail.title"
							values={{
								taskName,
								taskCultureName: task.culture ? ` - ${task.culture.nom}` : ''
							}}
						/>
					</Typography>
				</Grid>
				{!showEditionTask && <Grid item className={classes.closeIcon}>
					<IconButton onClick={closeDetail}>
						<KeyboardArrowRightIcon />
					</IconButton>
				</Grid>}
			</Grid>
			<Grid
				item
				container
				className={classes.content}
				style={{
					height: isTablette ? 'calc(100vh - 300px)' : 'calc(100vh - 220px)',
					marginBottom: !isTablette ? 100 : 0
				}}
			>
				<Grid container alignContent="flex-start">
					{(!isResultat && !showEditionTask) && <Grid container alignItems="center" justify="center" style={{height: 50}}>
						<Button
							type="primary"
							variant="text"
							withBorder={false}
							keepCase
							onClick={() => setShowEditionTask(true)}
						>
							<Grid item container direction="row" justify="center" alignItems="center" style={{gap: 10}}>
								<CreateIcon color="primary" />
								<Typography color="primary">
									<FormattedMessage id="tourPlaine.form.updateTask.updateAction" />
								</Typography>
							</Grid>
						</Button>
						<Button
							type="primary"
							variant="text"
							withBorder={false}
							keepCase
							onClick={openDeletionPopin}
						>
							<Grid item container direction="row" justify="center" alignItems="center" style={{gap: 10}}>
								<DeleteForeverIcon color="primary" />
								<Typography color="primary">
									<FormattedMessage id="tourPlaine.form.updateTask.deleteAction" />
								</Typography>
							</Grid>
						</Button>
					</Grid>}
					{showEditionTask ? <>
							<Grid item container className={isTablette ? classes.updateContainerTablette : classes.updateContainer}>
								<UpdateTaskForm
									task={updateFormDetails}
									onSuccess={updateSuccess}
									onSubmit={submitUpdate}
									fromScheduler
								/>
							</Grid>
							<Grid item container justify="center" alignContent="center" className={isTablette ? classes.actionsTablette : classes.actions}>
								<Grid item>
									<Button
										type="cancel"
										key="cancel"
										onClick={() => {
											setShowEditionTask(false)
											refreshScheduler()
											closeDetail()
										}}
										className={classes.actionButton}
									>
										<FormattedMessage id="actions.cancel" />
									</Button>
								</Grid>
								<Grid item>
									<FormButton
										className={classes.submitButton}
										type="primary"
										formName={PANEL_FORM.UPDATE_TASK}
										disabled={false}
										getDisabledFromState={undefined}
									>
										<FormattedMessage id="tourPlaine.form.submit" />
									</FormButton>
								</Grid>
							</Grid>
						</>
						: <>
							{taskPanelRedirection.unplanned && <Grid container justify="center">
								<Typography style={{fontStyle: 'italic', margin: '12px 1.5em 0px 1.5em', textAlign: 'center'}}>
									<FormattedMessage id="tourPlaine.form.updateTask.unplanned" />
								</Typography>
							</Grid>}
							<Detail sections={sections} />
						</>}
				</Grid>
			</Grid>
		</Grid>
	</Grid>
}

type TaskDetailParentProps = {
	taskPanelRedirection: TaskPanelRedirectionParameters
	isResultat: boolean
	closeDetail: () => void
}

export default compose<FC<TaskDetailParentProps>>(
	withStyles(styles),
	injectTypeTacheValueList
)(TaskDetail)